module.exports = __webpack_public_path__ + "img/1438336053.fa8f214a.jpg";